import script from "./FixedAdDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedAdDrawer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__